// jshint esversion: 8
import axios from 'axios';
const distinctiveProps = [
  '_id',
  'name',
  'coachManagerSerialNumber',
  'companySerialNumber'
];

const getHeaders = (rootState) => ({ Authorization: rootState['auth/token'] });

const fetchIntegrations = async ({ commit, rootGetters }, qs) => {
  const headers = getHeaders(rootGetters);
  const url = process.env.VUE_APP_INTEGRATIONS_URL + '/integrations/' + qs;
  const { data } = await axios.get(url, { headers });
  const { integration } = data;
  console.log(integration)
  if (integration && integration.type === 'distinctive') {
    distinctiveProps.forEach(prop => {
      if (integration.hasOwnProperty(prop)) {
        commit('SET_DISTINCTIVE', { prop, val: integration[prop] });
      }
    });
  }
};

const dumpDistinctiveData = async ({ commit, getters, rootGetters }, payload) => {
  payload.companyName = getters.distinctive.companyName;
  payload.password = getters.distinctive.password;
  const query = { _id: getters.distinctive._id };
  const headers = getHeaders(rootGetters);
  const url = process.env.VUE_APP_INTEGRATIONS_URL + '/integrations/';
  return await axios.patch(url, { payload, query }, { headers });
};

export default {
  fetchIntegrations,
  dumpDistinctiveData
};
